import { Box, TextField, Button, Paper, Stack } from '@mui/material';

export default function NoteForm({ title, body, setTitle, setBody, onSubmit, onCancel, isEditing }) {
  return (
    <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
      <form onSubmit={onSubmit}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
          <Box sx={{ flex: 2 }}>
            <TextField
              label="Title"
              variant="outlined"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              size="small"
              sx={{ mb: 1 }}
            />
            <TextField
              label="Write your note..."
              variant="outlined"
              fullWidth
              multiline
              minRows={4}
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
          </Box>

          <Box sx={{ width: { xs: '100%', md: 220 }, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Button type="submit" variant="contained" size="large" fullWidth>
              {isEditing ? 'Save Changes' : 'Add Note'}
            </Button>
            {isEditing && (
              <Button variant="outlined" size="large" onClick={onCancel} fullWidth>
                Cancel
              </Button>
            )}
            <Box sx={{ mt: 'auto', color: 'text.secondary', fontSize: 12 }}>
              Quick filters are below (use filters panel)
            </Box>
          </Box>
        </Stack>
      </form>
    </Paper>
  );
}
